export default __webpack_public_path__ + "static/media/oh noo.a9d05c64.png";